export var breakpointsOptions = {
    // default except lg
    values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: false,
        xl: 1536,
    },
};
